<template>
  <div class="d-flex">
    <div class="d-flex-left" :class="is_close_project?'close':''">
<!--      <div :style="{display: (is_close_project?'none':'block')}">-->
<!--        -->
<!--      </div>-->
      <erp-tree-status v-show="!is_close_project" @node-click="nodeClick" />
      <div class="close-btn" :class="is_close_project?'close':''">
        <el-button size="mini" round @click="is_close_project=!is_close_project">{{is_close_project?'展开':'收起'}}</el-button>
      </div>
    </div>
    <div class="d-flex-right">
      <transition name="slide-fade" mode="out-in">
        <keep-alive>
          <component :is="componentId"/>
        </keep-alive>
      </transition>
    </div>
  </div>
</template>

<script>
import ErpTreeStatus from "../Common/erp-tree-status";
import VirtuallyMain from "./components/virtually/VirtuallyMain.vue";
import VirtuallyEditor from "./components/virtually/VirtuallyEditor";
export default {
  name: "Virtually",
  components: {
    ErpTreeStatus,
    VirtuallyMain,
    VirtuallyEditor
  },
  inject:['mainObj','componentId','setComponentId'],
  provide(){
    return{
      mainObj:this.mainObj,
      componentId:this.componentId,
      setComponentId:this.setComponentId,
    }
  },
  data(){
    return{
      mainObj:{
        house_name:"",
        house_id:"",
        project_id:"",
        id:"",
        type:""
      },
      componentId:"VirtuallyMain",
      is_close_project:false,
    }
  },
  methods:{
    nodeClick(data) {
      const that=this;
      that.mainObj.house_name = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      that.mainObj.project_id = data.tree[0].pindex_id;
      if (data.tree[data.tree.length - 1].type === "room") {
        that.mainObj.house_id = data.tree[data.tree.length - 1].id;
      } else {
        that.mainObj.house_id = 0;
      }
    },
    setComponentId(componentId){
      this.componentId=componentId;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "common";
.d-flex {
  display: flex;
  margin: 10px;
  .d-flex-left {
    margin-right: 10px;
    border-right: 1px solid #eee;
    padding-right: 10px;
    position: relative;
    height: 85vh;

    &.close{
      width: 0 !important;
      //overflow-x: hidden;
    }
    .close-btn{
      position: absolute;
      top: 50%;
      right: 0;
      z-index: 10;
      &.close{
        right: -60px;
      }
    }

  }

  .d-flex-right {
    flex: 1;
    overflow-x:hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/MeterVirtually/Virtually.vue